module.exports = __webpack_public_path__ + "static/img/bg-function-1.3b83929f.png";